import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, CargoHistorico } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class CargoHistoricoService extends BaseResourceService<CargoHistorico> {

  constructor(
    protected injector: Injector
  ) {
    super(`cargos-historicos`, injector);
  }

}
